import React from 'react'

export const BellIcon: React.FC = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='19.24'
			height='23.09'
			className='bell-icon-svg'
			viewBox='0 0 19.24 23.088'>
			<g id='bell' transform='translate(-2)'>
				<path
					id='Path_3477'
					data-name='Path 3477'
					d='M20.643,16.271a6.443,6.443,0,0,1-2.289-4.93V8.658A6.739,6.739,0,0,0,12.582,2V.962a.962.962,0,0,0-1.924,0V2A6.739,6.739,0,0,0,4.886,8.658V11.34a6.451,6.451,0,0,1-2.3,4.938A1.683,1.683,0,0,0,3.684,19.24H19.557a1.683,1.683,0,0,0,1.086-2.97Z'
					fill='#3b2a82'
				/>
				<path
					id='Path_3478'
					data-name='Path 3478'
					d='M11.86,23.886A3.613,3.613,0,0,0,15.395,21H8.326A3.613,3.613,0,0,0,11.86,23.886Z'
					transform='translate(-0.24 -0.798)'
					fill='#3b2a82'
				/>
			</g>
		</svg>
	)
}
